import React from 'react';
import "./aboutCard.css"
const AboutCard = ({ info }) => {

    return (
        <div className="col-md-4 aboutCard ">
            <div className="card-container">
                <div className="d-flex justify-content-center">
                    <div className="card-media ">
                        <img src={info?.logo?.url} className="img-fluid " alt="card logo" />
                    </div>
                </div>

                <div className="card-text m-0 p-0 text-center ">
                    <h1 >{info?.title1[0]?.text}</h1>
                    <p>{info?.sub_title[0]?.text}</p>
                </div>

            </div>

        </div>
    );
};

export default AboutCard;